import { Component, ViewChild } from '@angular/core';
import { HashComponent } from '../hash/hash.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-test-hash',
  templateUrl: './test-hash.component.html',
  styleUrls: ['../hash/hash.component.css', '../t-hash/t-hash.component.css', './test-hash.component.css']
})
export class TestHashComponent extends HashComponent {

  @ViewChild('definitionForm', {static:true}) public definitionForm: NgForm;

  selectionS: string;
  open: boolean = false;
  shortElements: any[] = [];
  useAll: boolean = false;


  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    this.elementType = this.configuration.typespecifics.elementType;
    this.elements = this.configuration.typespecifics.elements;
    this.hashed = [];
    this.typeFunction = "digits";
    this.selection = [];
    this.divisor = undefined;
    this.scalar = undefined;
    this.compute = ["precomputation", "scale", "modulo", "operation"];
    this.hashElements = true;
    this.shortElements = this.elements.slice(0, Math.min(this.elements.length, 10));
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific != undefined) {
      if (this.state.typespecific.scalar) {
        this.scalar = this.state.typespecific.scalar;
      }
      if (this.state.typespecific.divisor) {
        this.divisor = this.state.typespecific.divisor;
      }
      if (this.state.typespecific.selection) {
        this.selection = this.state.typespecific.selection;
        this.selectionS = this.selection.toString();
      }
      if (this.state.typespecific.typeFunction) {
        this.typeFunction = this.state.typespecific.typeFunction;
      }
      this.changeHash();
    }
  }

  computeState() {
    this.state.typespecific.scalar = this.scalar;
    this.state.typespecific.divisor = this.divisor;
    this.state.typespecific.selection = this.selection;
    this.state.typespecific.typeFunction = this.typeFunction;
  }

  /** returns a string representation of the hash function */
  getHashFunction(): string {
    let separator = "";
    let result = "";
    if (this.typeFunction == 'digits') {
      if (this.selection != undefined) {
        for (let i of this.selection) {
          result = result.concat("a", i.toString());
        }
      }
      return result;
    }

    if (this.typeFunction == 'checksum') {
      return this.get("checksum");
    }
    if (this.selection != undefined) {
      if (this.useAll) {
        if (this.typeFunction == "addition") {
          result = "a0 + a1 + ...";
        } else {
          result = "a0 * a1 * ...";
        }
      } else {
        for (let i of this.selection) {
          result = result.concat(separator, "a".concat(i.toString()));
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }
      }
    }
    result = "((".concat(result, ")", " * ", this.scalar ? this.scalar.toString() : "???", ")", " % ", this.divisor ? this.divisor.toString() : "???")
    return result;
  }

  /** returns a string representation of the addition / multiplication */
  getOperationString(): string {
    let result = "";
    if (this.selected.precomputed != undefined) {
      let separator = "";
      if (this.selection.length > 0) {
        for (let i of this.selection) {
          if (this.selected.precomputed[i] == undefined) {
            if (this.typeFunction == "addition") {
              result = result.concat(separator, "0");
            } else {

              result = result.concat(separator, "1");
            }

          } else {
            result = result.concat(separator, this.selected.precomputed[i]);
          }
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }
      } else {
        for (let i of this.selected.precomputed) {
          result = result.concat(separator, i);
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }

      }
    }
    return result;
  }

  checkSolution() {}

  /** called when the fixed elements change */
  changeSelectionS() {
    this.selection = this.selectionS.split(",").map(v => +v);
    this.selection = this.selection.filter(v => !Number.isNaN(v)).map(v => Math.floor(v));
    this.selection = Array.from(new Set(this.selection));
    this.selectionS = this.selection.toString();
    this.changeHash();
  }

  /** recomputes the hashing */
  changeHash() {
    if (this.typeFunction == 'digits') {
      this.computeBuckets();
    }
    if(this.typeFunction == 'checksum'){
      this.divisor = 10;
    }
    if ((this.typeFunction == "checksum")||(this.typeFunction=='digits'&&this.selection) || ((this.typeFunction=='addition' || this.typeFunction=='multiplication') && this.scalar && this.divisor && this.selection)) {
      this.hashed = [];
      this.data = [];
      for (let i = 0; i < this.divisor; i++) {
        this.hashed.push([]);
        this.data.push({ name: i.toString(), value: 0 });
      }
      this.hashed.push([]);
      let last = this.hashed[this.hashed.length - 1]
      for (let element of this.elements) {
        let elem = {
          value: element,
          precomputed: undefined,
          operation: undefined,
          scaled: undefined,
          hash: undefined
        };
        this.selected = elem;
        if (this.elementType == 'number') {
          this.precomputationS = element.toString().split("").join(",");
          this.changePrecomputation(true);
        } else {
          this.precomputationS = element.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
          this.changePrecomputation(true);
        }
        this.data[elem.hash].value++;
      }
      this.data = [...this.data];
    }
  }

  /** recomputes the hashing */
  changeUseAll() {
    if (this.useAll) {
      this.selection = []; 
      this.changeHash();
    } else {
      this.changeSelectionS();
      this.changeHash();
    }
  }

  /** checks whether elements are larger the the highest index */
  elementsLarger():boolean{
    let max = 7;
    if(this.elementType == 'number'){
      max = this.elements[0].length;
    }
    for(let s of this.selection){
      if (+s > max){
        return true;
      }
    }
    return false;
  }

  save() {
    this.solved = true;
    this.state.solved = true;
    this.saveState();
  }
}
